/**
 * Registers the `admin` translation namespace.
 *
 * Imported only by the admin control panel, so `locales/en/admin.json` never
 * reaches the user-facing bundles — the default `translation` namespace in
 * `i18n/index.ts` stays untouched, and neither set of keys can collide with the
 * other.
 *
 * Use: import '@wlb/shared/i18n/registerAdmin';
 *      const { t } = useTranslation('admin');
 */
import i18n from './index';
import admin from '../locales/en/admin.json';

export const ADMIN_NAMESPACE = 'admin';

i18n.addResourceBundle('en', ADMIN_NAMESPACE, admin, true, false);

export default i18n;
